import { ReactNode } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  footer: {
    gridArea: 'foot',
    minWidth: 0,
    minHeight: 0,
  }
});

function Footer({ children }: { children: ReactNode }) {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      {children}
    </div>
  );
}

export default Footer;
